import { Injectable } from '@angular/core';

@Injectable()
export class NotificationService {
    private readonly loader: HTMLElement;

    constructor() {
        this.loader = document.getElementById('indicator');
    }

    public showLoader(): void {
        this.loader.style.display = 'block';
    }

    public hideLoader(): void {
        this.loader.style.display = 'none';
    }
}
